const INITIAL_BASIC_INFO = {
  name: '',
  code: '',
  createdBy: '',
  createdDate: '',
  description: ''
};

// eslint-disable-next-line import/prefer-default-export
export { INITIAL_BASIC_INFO };
